import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

export const mapFields = (data: ModuleFields[]) =>
  data.map(({ fieldName, placeholder, name, formType, validation, className, usedFileType }) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    usedFileType: usedFileType
  }));

export const fields: any = {
  manualWelcomePage: mapFields(drilldownData["manualWelcomePage"]),
  procurementPlanning: mapFields(drilldownData["procurementPlanning"]),
  procurementPlanningProcessFlowChart: mapFields(drilldownData["procurementPlanningProcessFlowChart"]),
  requisition: mapFields(drilldownData["requisition"]),
  requisitionProcessFlowChart: mapFields(drilldownData["requisitionProcessFlowChart"]),
  contractAdministration: mapFields(drilldownData["contractAdministration"]),
  contractAdministrationProcessFlowChart: mapFields(drilldownData["contractAdministrationProcessFlowChart"]),
  vendorManagement: mapFields(drilldownData["vendorManagement"]),
  vendorManagementProcessFlowChart: mapFields(drilldownData["vendorManagementProcessFlowChart"]),
  sourcing: mapFields(drilldownData["sourcing"]),
  sourcingProcessFlowChart: mapFields(drilldownData["sourcingProcessFlowChart"]),
  introduction: mapFields(drilldownData["introduction"]),
};
